import { useRequest } from 'features/request/useRequest';
import { useResetMultipleStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import type { RatioIdType } from '../../types';
import { catalogRatioGql } from '../catalogRatiosQueries';

export const useRatio = (id: Exclude<RatioIdType, undefined>) => {
    const variables = useMemo(() => (id ? { id } : undefined), [id]);

    const memoizedRequestIds = useMemo(() => [`catalogRatio_${id}`], [id]);

    const [variableReset] = useResetMultipleStoreData({
        requestIds: memoizedRequestIds,
    });

    useEffect(
        () => () => {
            variableReset();
        },
        [variableReset],
    );

    const [ratioData, ratioStatus] = useRequest({
        requestId: `catalogRatio_${id}`,
        query: catalogRatioGql,
        variables,
        withEffect: !!id,
    });

    return useMemo(
        () => ({
            ratioData: ratioData?.catalogRatio?.data,
            ratioStatus,
        }),
        [ratioData?.catalogRatio, ratioStatus],
    );
};
